<template>
  <div class="big">
    <ReturnVisit
      :isFlag="return_visit"
      :businessId="patientId"
      :visitType="visitType"
      :visitName="visitName"
      :sms_type="4"
      :activeIndexDia="activeIndexDia"
    ></ReturnVisit>
    <div>
      <div class="toptitle">
        <div style="display: flex; align-items: center">
          <div>
            <span>患者信息详情</span>
            <el-button
              type="primary"
              style="width: 80px; margin-left: 20px"
              size="medium"
              @click="toReturn"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1315') : false
              "
              >回访</el-button
            >
          </div>
          <div class="status" v-if="status">该患者已被用户删除</div>
        </div>
        <el-button
          type="primary"
          style="width: 92px"
          size="medium"
          @click="back"
          >返回</el-button
        >
      </div>
    </div>

    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div>
          <div>
            <el-menu
              :default-active="activeIndex"
              class="el-menu-demo noneline"
              mode="horizontal"
              @select="handleSelect"
            >
              <el-menu-item index="1" class="title" style="font-size: 16px"
                >患者信息</el-menu-item
              >
              <!--  :disabled="module_id_array[0]?!module_id_array.includes('45'):false" 问诊记录-->
              <el-menu-item
                index="2"
                class="title space"
                style="font-size: 16px"
                >问诊记录</el-menu-item
              >
              <el-menu-item
                index="3"
                class="title space"
                style="font-size: 16px"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('55') : false
                "
                >处方记录</el-menu-item
              >
              <el-menu-item
                index="4"
                class="title space"
                style="font-size: 16px"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('47') : false
                "
                >病历记录</el-menu-item
              >
            </el-menu>
          </div>
          <div class="box">
            <div class="component">
              <component :is="currentComponent" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PatientMsg from "./PatientMsg";
import WenzhenLog from "./WenzhenLog";
import ChufangLog from "./ChufangLog";
import BingliLog from "./BingliLog";
import patient from "../../../api/patient";
import ReturnVisit from "../../../components/common/ReturnVisit.vue";

export default {
  data() {
    return {
      activeIndex: "1",
      active: "",
      status: "",
      return_visit: false,
      patientId: 0,
      visitName: "patient",
      visitType: 2,
      activeIndexDia: "1",
    };
  },
  computed: {
    currentComponent() {
      switch (this.active) {
        case "1":
          return PatientMsg;
        case "2":
          return WenzhenLog;
        case "3":
          return ChufangLog;
        case "4":
          return BingliLog;
        default:
          return PatientMsg;
      }
    },
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  components: {
    ReturnVisit,
  },
  methods: {
    handleSelect(key) {
      this.active = key;
    },
    back() {
      history.back();
    },
    getStatus() {
      let patient_id = this.$route.query.patient_id;
      patient
        .patientItem({ patient_id })
        .then((res) => {
          if (res.code == 0) {
            this.status = res.data.info.is_delete;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //回访
    toReturn() {
      this.patientId = this.$route.query.patient_id;
      this.return_visit = !this.return_visit;
    },
  },
  created() {
    this.getStatus();
  },
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 205px);
}

.box {
  width: 100%;
  box-sizing: border-box;

  .component {
    width: 100%;
    box-sizing: border-box;
  }
}
.toptitle {
  width: 100%;
  height: 50px;
  line-height: 50px;
  padding: 0 24px;
  box-sizing: border-box;
  font-size: 18px;
  background: #fbfbfb;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .status {
    color: #f24b2f;
    background: #ffe4dd;
    border-radius: 2px;
    font-size: 12px;
    height: 30px;
    line-height: 30px;
    padding: 0 10px;
    margin-left: 30px;
  }
}
</style>
